export default "<div class=\"blue\">\n    <div class=\"white\">\n        <app-user-list></app-user-list>\n    </div>\n</div>";